import React, { useState } from 'react';
import Sticky from 'react-sticky-el';
import { Button, Text } from '@perch-labs/shrike';
import { MAX_NAV_WIDTH, zIndexStickyClosedBanner } from 'domain/style';
import { copyFor } from 'config';
import { ReactivatePlan } from 'components/modals/reactivate-plan/modal.component';
import { Grid, GridCell } from 'styles';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { REACTIVATION_SOURCE } from 'components/modals/reactivate-plan/modal.constants';
import { ButtonWrapper, Banner } from './inactive-plan-banner.style';

const getCopy = copyFor('closed');

export const InactivePlanBanner = ({
  showReactivateButton,
  planId,
  planName,
  onRefresh,
}) => {
  const [showReactivateModal, setShowReactivateModal] = useState(false);
  const flag = useFlags();
  const toggleReactivationModal = event => {
    if (event?.refreshDashboard) {
      onRefresh();
    }
    setShowReactivateModal(!showReactivateModal);
  };
  return (
    <>
      <Sticky stickyStyle={{ zIndex: zIndexStickyClosedBanner }}>
        <Banner>
          <Grid maxWidth={MAX_NAV_WIDTH} margin="auto" height="64px">
            <GridCell columnStart={2} height="100%" columns={2}>
              <Text
                color="primaryInverse"
                textStyle="paragraph400"
                margin="22px 0"
              >
                {getCopy('banner')}
              </Text>
            </GridCell>
            <GridCell
              columnStart={10}
              height="100%"
              columns={2}
              justifySelf="end"
            >
              {flag.lbReactivationPlanEnabled && showReactivateButton && (
                <ButtonWrapper>
                  <Button
                    color="primaryInverse"
                    backgroundless
                    size="small"
                    onClick={toggleReactivationModal}
                    data-testid="reactivate-plan-button"
                  >
                    {getCopy('reactivate')}
                  </Button>
                </ButtonWrapper>
              )}
            </GridCell>
          </Grid>
        </Banner>
      </Sticky>
      {showReactivateModal && (
        <ReactivatePlan
          planId={planId}
          planNickname={planName}
          onClose={toggleReactivationModal}
          source={REACTIVATION_SOURCE.PLAN_BANNER}
        />
      )}
    </>
  );
};
